import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import Table from '../../../../components/tables/Table';
import { SET_VIEW_READ_ONLY } from '../../../../components/context/reducer/actionTypes';
import useTableActions from '../../../../hooks/useTableActions';
import useHasPermission from '../../../../hooks/useHasPermission';
import ListsContainer from '../../../../components/ListsContainer/ListsContainer';
import EnabledColumn from '../../../../components/EnabledColumn/EnabledColumn';
import EditComponentCheckbox from '../../../../components/EditComponentCheckbox';

const JobTypesList = () => {
  const history = useHistory();
  const [pageSize, setPageSize] = useState(10);
  const tableRef = useRef(null);
  const { globalDispatch, fetchItem } = useContext(DashboardPanelContext);
  const [columns, setColumns] = useState([]);
  const [key, setKey] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchItem({
      modelName: `/job-types`,
      showLoader: true,
    }).then((response) => {
      if (response) {
        setData(response.data.filter((d) => d.id !== 1));
      }
    });
    setColumns([
      {
        title: 'Title',
        field: 'title',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Private Price-1 (Low price - not home)',
        field: 'private_price_1',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Insurance Price-1 (Low price - not home)',
        field: 'insurance_price_1',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Price-2 (Just inspect)',
        field: 'price_2',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Price-3 (Complete Price)',
        field: 'price_3',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Price-4 (Manual adding for an extra job)',
        field: 'price_4',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Description',
        field: 'description',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Status',
        field: 'status',
        type: 'boolean',
        render: EnabledColumn,
        editComponent: EditComponentCheckbox,
        filtering: false,
        sorting: false,
      },
    ]);
    setKey(key + 1);
  }, []);

  const actions = useTableActions({
    updatePermission: 'ADMIN',
    deletePermission: '',
    editURL: '/order-management/job-type/',
    removePATH: 'job-types',
    tableRef,
  });

  const handleCreate = () => {
    globalDispatch({ type: SET_VIEW_READ_ONLY, value: false });
    history.push('/order-management/job-type');
  };

  const onRowClick = (event, rowData) => {
    globalDispatch({ type: SET_VIEW_READ_ONLY, value: true });
    history.push(`/order-management/job-type/${rowData.id}`);
  };

  return (
    <ListsContainer>
      <Table
        key={key}
        title='Job Type List'
        columns={columns}
        createSlug='Add Job Type'
        exportCsv={false}
        actions={actions}
        createAction={useHasPermission('ADMIN') ? handleCreate : undefined}
        tableRef={tableRef}
        data={data}
        onRowClick={onRowClick}
        onChangeRowsPerPage={(pgSize) => {
          setPageSize(pgSize);
        }}
        pageSize={pageSize}
        filtering={false}
        sortableColumns
      />
    </ListsContainer>
  );
};

export default JobTypesList;
